export default "__VITE_ASSET__e9e955f3__"